export enum CreativeTagEvent {
  CreativeInit = 'creativeInit',
  CreativeRequested = 'creativeRequested',
  CreativeLoaded = 'creativeLoaded',
  CreativeLoadingFailed = 'creativeLoadingFailed',
  CreativeAssetLoad = 'creativeAssetLoad',
  CreativeDisplay = 'creativeDisplay',
  CreativeView = 'creativeView',
  CreativeTimespent = 'creativeTimespent',
  CreativeShow = 'creativeShow',
  CreativeClicked = 'creativeClicked',

  CreativeReached = 'creativeReached',
  CreativeCompleted = 'creativeCompleted',
  CreativeChapterViewed = 'creativeChapterViewed',
  CreativeNavigationSlide = 'creativeNavigationSlide',
  CreativeNavigationSiteScroller = 'creativeNavigationSiteScroller',
  CreativeRedirection = 'creativeRedirection',

  VideoStart = 'videoStart',
  VideoFirstQuartile = 'videoFirstQuartile',
  VideoMidpoint = 'videoMidpoint',
  VideoThirdQuartile = 'videoThirdQuartile',
  VideoComplete = 'videoComplete'
}
